<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <v-container class="toolbar__container">
      <v-form ref="form" v-model="formValidado">
        <v-row>
          <v-col cols="12" sm="12" md="5">
            <v-autocomplete v-model="idEmpresaSelected" :items="empresas" item-text="razao_social"
              item-value="id_empresa" clearable :label="$tc('company.self', 1)" @change="onEmpresaSelectChanged"></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="3">
            <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
              :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
              date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
              <template slot="dateIcon">
                <v-icon>mdi-calendar</v-icon>
              </template>
              <template slot="timeIcon">
                <v-icon>mdi-clock</v-icon>
              </template>
            </v-datetime-picker>
          </v-col>
          <v-col cols="12" sm="4" md="1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                  @click="populaViagens">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('operation.search') }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row v-if="idEmpresaSelected">
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete v-model="idLinhaSelected" :items="linhasSelect" item-text="nome_linha" item-value="id_linha"
              clearable :label="$tc('line.self', 1)" @change="linhasSelectChanged" :disabled="isLinhaSelectDisabled">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete v-model="idVeiculoSelected" :items="veiculosSelect" item-text="numero_ordem"
              item-value="id_veiculo" clearable multiple :label="$tc('vehicle.self', 2)" @change="veiculosSelectChanged"
              :disabled="isVeiculoSelectDisabled">
              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="toggleAllVeiculos">
                  <v-list-item-action>
                    <v-icon :color="idVeiculoSelected.length > 0 ? 'indigo darken-4' : ''">
                      {{ selectIcon(idVeiculoSelected, veiculosSelect) }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('operation.all') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ item, index }">
                <span v-if="index <= 3" style="margin-right: 5px;">{{ item.numero_ordem }}</span>
                <v-chip v-if="index === 4" class="grey--text text-caption">
                  <span>(+{{ idVeiculoSelected.length - 4 }} {{ $t('operation.others') }})</span>
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-autocomplete v-model="idFuncionarioSelected" :items="funcionariosSelect" item-text="nome"
              item-value="id_funcionario" multiple clearable :label="$tc('employee.self', 1)"
              :disabled="isFuncionarioSelectDisabled" @change="funcionariosSelectChanged">

              <template v-slot:prepend-item>
                <v-list-item ripple @mousedown.prevent @click="toggleAllFuncionarios">
                  <v-list-item-action>
                    <v-icon :color="idFuncionarioSelected.length > 0 ? 'indigo darken-4' : ''">
                      {{ selectIcon(idFuncionarioSelected, funcionariosSelect) }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t('operation.all') }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-2"></v-divider>
              </template>

              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" style="margin-right: 5px;">{{ item.nome }}</span>
                <span v-if="index === 1" class="grey--text text-caption">
                  (+{{ idFuncionarioSelected.length - 1 }} {{ $t('operation.others') }})
                </span>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row v-if="idLinhaSelected">
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete v-model="idQuadroSelected" :items="quadrosSelect" item-text="descricao"
              item-value="id_quadro" clearable :label="$t('telemetry.table')" @change="quadrosSelectChanged">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-autocomplete v-model="idViagemSelected" :items="viagensSelect" item-text="descricao_viagem"
              item-value="id_viagem" clearable :label="$tc('trip.self', 1)" @change="viagensSelectChanged">
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </v-container>

    <v-data-table :headers="headers" :items="telemetriaDados" sort-by="id_empresa" dense class="elevation-7" locale="pt"
      :loading="loading" :loading-text="$t('system.messages.loading')" :search="search"
      style="border-radius: 10px; margin-bottom: 10px;margin-top: 10px;">
      <template v-slot:top>
        <v-toolbar flat color="white" style="border-radius: 10px;">
          <v-toolbar-title style="color: #4a4a4a">{{ $t('telemetry.self') }}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-text-field v-model="search" append-icon="mdi-magnify" :label="$t('system.search')" single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>

          <vue-json-to-csv :json-data="telemetriaDados" :csv-title="'telemetria'" separator=";">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="primary" dark small class="mb-2 mr-2" fab>
                  <v-icon>mdi-export-variant</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('system.labels.exportToCsv') }}</span>
            </v-tooltip>
          </vue-json-to-csv>

          <export-table-pdf title="Telemetria" :content="telemetriaDados" :headers="headers" :subtitle="pdfsubtitle"
            filename="telemetria"></export-table-pdf>

          <template v-slot:extension>
            <v-tabs v-model="tab" align-with-title>
              <v-tab>{{ $tc('trip.self', 2) }}</v-tab>
              <v-tab>{{ $tc('company.self', 2) }}</v-tab>
              <v-tab>{{ $tc('line.self', 2) }}</v-tab>
              <v-tab>{{ $tc('vehicle.self', 2) }}</v-tab>
              <v-tab>{{ $tc('employee.self', 2) }}</v-tab>
            </v-tabs>
          </template>

        </v-toolbar>
      </template>

      <template v-slot:item.km_total="{ item }">
        <div>{{ item.km_total?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.diesel_total="{ item }">
        <div>{{ item.diesel_total?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.diesel_km="{ item }">
        <div>{{ item.diesel_km?.toFixed(2) }}</div>
      </template>

      <template v-slot:item.km_ociosa="{ item }">
        <div>{{ item.km_ociosa?.toFixed(2) }}</div>
      </template>
      <template v-slot:item.ipk="{ item }">
        <div>{{ item.ipk?.toFixed(2) }}</div>
      </template>
    </v-data-table>

  </v-container>
</template>

<script>
import apiController from "@/utils/apiController";
import VueJsonToCsv from "vue-json-to-csv";
import ExportTablePdf from "./ExportTablePdf.vue";
import DateUtils from "../utils/dateutils";

export default {
  components: {
    VueJsonToCsv,
    ExportTablePdf
  },
  data: () => ({
    search: "",
    user: null,
    mensagemAutorizacaoDialog: "",
    autorizacaoDialog: false,
    showConfirmButton: true,
    formValidado: false,
    loading: false,
    timeProps: {
      useSeconds: true,
    },
    dti: null,
    dtf: null,
    idEmpresaSelected: null,
    idLinhaSelected: null,
    cercasTrechosSelected: [],
    idVeiculoSelected: [],
    empresas: [],
    veiculosSelect: [],
    linhasSelect: [],
    veiculos: [],
    posicoes: [],
    funcionarios: [],
    funcionariosSelect: [],
    idFuncionarioSelected: [],
    config: null,
    dados: { empresas: [], linhas: [], veiculos: [] },
    telemetria: [],
    quadros: [],
    idQuadroSelected: null,
    viagens: [],
    idViagemSelected: null,
    tab: 0,
    viagensPrevistas: [],
  }),
  computed: {
    headersBase() {
      return [
        { text: this.$t('telemetry.headersBase.kmTotal'), value: "km_total" },
        { text: this.$t('telemetry.headersBase.kmIdle'), value: "km_ociosa" },
        { text: this.$t('telemetry.headersBase.dieselTotal'), value: "diesel_total" },
        { text: this.$t('telemetry.headersBase.kmDiesel'), value: "diesel_km" },
        { text: this.$t('telemetry.headersBase.ipk'), value: "ipk" }]
    },
    headersViagens() {
      return [
        { text: this.$t('telemetry.headersViagens.line'), value: "cod_linha" },
        { text: this.$t('telemetry.headersViagens.vehicle'), value: "numero_ordem" },
        { text: this.$t('telemetry.headersViagens.direction'), value: "descricao_sentido" },
        { text: this.$t('telemetry.headersViagens.shift'), value: "descricao_turno" },
        { text: this.$t('telemetry.headersViagens.driver'), value: "nome_motorista" },
        { text: this.$t('telemetry.headersViagens.start'), value: "dt_inicio_extenso" },
        { text: this.$t('telemetry.headersViagens.end'), value: "dt_fim_extenso" },
        { text: this.$t('telemetry.headersViagens.kmTotal'), value: "km_total_viagem" },
        { text: this.$t('telemetry.headersViagens.dieselTotal'), value: "diesel_total_viagem" },
        { text: this.$t('telemetry.headersViagens.kmDiesel'), value: "diesel_km_viagem" },
        { text: this.$t('telemetry.headersViagens.ipk'), value: "ipk" }]
    },
    textFieldProps: {
      prependInnerIcon: "mdi-calendar",
      rules: [(v) => !!v || this.$t('contract.messages.selectDate')], // (v) => v > this.dtfimbase || "Data início deve ser menor que data fim !"]
    },
    pdfsubtitle() {
      let subtitle = ""
      return subtitle;
    },
    yesterday() {
      let d = new Date();
      d.setDate(d.getDate() - 1);
      return d.toISOString().substring(0, 10);
    },
    dtiProps() {
      return {
        max: this.yesterday
      }
    },
    dtfProps() {
      let min = null;
      if (this.dti) {
        if (typeof this.dti === 'string') {
          min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
        } else {
          min = this.dti.toISOString().substring(0, 10);
        }
      }
      return {
        min: min
      }
    },
    showViagensSelect() {
      return this.idLinhaSelected || this.idVeiculoSelected.length > 0 || this.idFuncionarioSelected.length > 0;
    },
    viagensSelect() {
      if (this.idQuadroSelected) {
        return this.viagensPrevistas.filter((v) => v.id_quadro == this.idQuadroSelected);
      }

      return [];
    },
    quadrosSelect() {
      if (this.dti && this.dtf) {
        let quadrosToShow = this.quadros.filter((q) => q.dt_inicio_vigencia_formatado <= DateUtils.getDateSQLFormatted(this.dtf) &&
          (q.dt_fim_vigencia === null || q.dt_fim_vigencia_formatado >= DateUtils.getDateSQLFormatted(this.dti)));

        if (this.idLinhaSelected) {
          quadrosToShow = quadrosToShow.filter((q) => q.id_linha == this.idLinhaSelected);
        }

        return quadrosToShow;
      }

      return [];
    },
    headers() {
      if (this.tab === 0) {
        return this.headersViagens;
      }

      let preHeaders = [];

      if (this.tab === 1) {
        preHeaders = [{ text: this.$tc('company.self', 1), value: "razao_social" }];
      }

      if (this.tab === 2) {
        preHeaders = [{ text: this.$tc('line.self', 1), value: "cod_linha" }]
      }

      if (this.tab === 3) {
        preHeaders = [{ text: this.$tc('vehicle.self', 1), value: "numero_ordem" }];
      }

      if (this.tab === 4) {
        preHeaders = [{ text: this.$tc('employee.self', 1), value: "nome_motorista" }];
      }

      return [...preHeaders, ...this.headersBase];
    },
    telemetriaDados() {
      let dadosToShow = [];

      if (this.tab === 0) {
        dadosToShow = this.viagens;

        if (this.idEmpresaSelected) {
          dadosToShow = dadosToShow.filter((d) => d.id_empresa == this.idEmpresaSelected);
        }

        if (this.idLinhaSelected) {
          dadosToShow = dadosToShow.filter((d) => d.id_linha == this.idLinhaSelected);
        }

        if (this.idVeiculoSelected.length > 0) {
          dadosToShow = dadosToShow.filter((d) => this.idVeiculoSelected.includes(d.id_veiculo));
        }

        if (this.idFuncionarioSelected.length > 0) {
          dadosToShow = dadosToShow.filter((d) => this.idFuncionarioSelected.findIndex((f) => f == d.matricula_motorista) !== -1)
        }

        if (this.idQuadroSelected) {
          dadosToShow = dadosToShow.filter((d) => d.id_quadro == this.idQuadroSelected);
        }

        if (this.idViagemSelected) {
          dadosToShow = dadosToShow.filter((d) => d.id_viagem_prevista == this.idViagemSelected);
        }

      } else if (this.tab === 1) {
        dadosToShow = this.dados.empresas;

        if (this.idEmpresaSelected) {
          dadosToShow = dadosToShow.filter((e) => e.id_empresa == this.idEmpresaSelected);
        }
      } else if (this.tab === 2) {
        dadosToShow = this.dados.linhas;

        if (this.idEmpresaSelected) {
          dadosToShow = dadosToShow.filter((e) => e.id_empresa == this.idEmpresaSelected);
        }

        if (this.idLinhaSelected) {
          dadosToShow = dadosToShow.filter((e) => e.id_linha == this.idLinhaSelected);
        }
      } else if (this.tab === 3) {
        dadosToShow = this.dados.veiculos;

        if (this.idEmpresaSelected) {
          dadosToShow = dadosToShow.filter((e) => e.id_empresa == this.idEmpresaSelected);
        }

        if (this.idLinhaSelected) {
          dadosToShow = dadosToShow.filter((e) => e.id_linha == this.idLinhaSelected);
        }

        if (this.idVeiculoSelected.length > 0) {
          dadosToShow = dadosToShow.filter((e) => this.idVeiculoSelected.includes(e.id_veiculo));
        }
      } else if (this.tab === 4) {
        dadosToShow = this.dados.funcionarios;

        if (this.idFuncionarioSelected.length > 0) {
          dadosToShow = dadosToShow.filter((e) => this.idFuncionarioSelected.includes(e.id_funcionario));
        }
      }

        return dadosToShow;
      },
      isVeiculoSelectDisabled() {
        return this.tab === 4;
      },
      isLinhaSelectDisabled() {
        return this.tab === 4;
      },
      isFuncionarioSelectDisabled() {
        return this.tab !== 4;
      }
    },
    watch: {
      '$i18n.locale'() {
        this.initialize();
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      }
    },
    created() {
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.initialize();
    },
    mounted() {},
    methods: {
      initialize() {
        this.getConfig();
        this.populaEmpresas();
        this.populaLinhas();
        this.populaVeiculos();
        this.populaFuncionarios();
        this.populaQuadros();
        this.populaViagensPrevistas();
      },
      getConfig() {
          apiController.request(apiController.endpoints.getallConfig, {
              onSuccess: (response) => {
                  this.config = response.data[0];
                  [this.dti, this.dtf] = DateUtils.setDefaultDateFiltersYesterday(this.config.hora_inicial_dia_operacao);
              },
          });
        },
      populaEmpresas() {
        apiController.request(apiController.endpoints.getallEmpresas, {
          onSuccess: (response) => {
            this.empresas = response.data;
          },
        });
    },
    populaLinhas() {
      apiController.request(apiController.endpoints.getLinhasativas, {
        onSuccess: (response) => {
          this.linhas = response.data;
        },
      });
    },
    populaVeiculos() {
      apiController.request(apiController.endpoints.getallVeiculosativos, {
        onSuccess: (response) => {
          this.veiculos = response.data;
        },
      });
    },
    populaFuncionarios() {
      apiController.request(apiController.endpoints.getallFuncionarios, {
        onSuccess: (response) => {
          this.funcionarios = response.data.filter((f) => f.categoria == 1);
        },
      });
    },
    populaQuadros() {
      apiController.request(apiController.endpoints.getallQuadros, {
        onSuccess: (response) => {
          this.quadros = response.data;
        },
      });
    },
    populaViagensPrevistas() {
      apiController.request(apiController.endpoints.getallViagensprevistas, {
        onSuccess: (response) => {
          this.viagensPrevistas = response.data;
        },
      });
    },
    populaViagens() {
      this.loading = true;
      let dataInicio = DateUtils.getDateSQLFormatted(this.dti);
      let dataFim = DateUtils.getDateSQLFormatted(this.dtf);

      apiController.request(apiController.endpoints.getVeiculosdashboardtelemetria, {
        params: { dti: dataInicio, dtf: dataFim },
        silent: true,
        onSuccess: (response) => {
          this.viagens = response.data;
          this.populaTelemetria();
        },
        onError: (e) => {
          this.loading = false;
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaTelemetria() {
      this.loading = true;
      const dataInicio = DateUtils.getDateSQLFormatted(this.dti);
      const dataFim = DateUtils.getDateSQLFormatted(this.dtf);

      apiController.request(apiController.endpoints.mercedesGetConsumoporperiodo, {
        params: { dti: dataInicio, dtf: dataFim },
        silent: true,
        onSuccess: (response) => {
          this.telemetria = response.data;
          this.populaDashboard();
        },
        onError: (e) => {
          this.loading = false;
          console.log(this.$t('system.messages.errorAxios'));
          console.log(e.message);
          if (e.message == "Request failed with status code 401") {
            this.mensagemAutorizacaoDialog =
              this.$t('system.messages.accessDenied');
            this.autorizacaoDialog = true;
          }
        },
      });
    },
    populaDashboard() {
      this.veiculos = this.veiculos.map((v) => {
        let telemetriaVeiculo = this.telemetria.find((t) => t.vehicle_id == v.cod_integracao_mercedes);
        if (telemetriaVeiculo) {
          let odometroIndex = telemetriaVeiculo.signals.findIndex((s) => s.signal_id === 4669);
          let dieselIndex = telemetriaVeiculo.signals.findIndex((s) => s.signal_id === 4662);
          v.km_total = (telemetriaVeiculo.signals[odometroIndex].lastDocument.signal_value - telemetriaVeiculo.signals[odometroIndex].firstDocument.signal_value) / 1000;
          v.diesel_total = telemetriaVeiculo.signals[dieselIndex].lastDocument.signal_value - telemetriaVeiculo.signals[dieselIndex].firstDocument.signal_value;
          v.diesel_km = v.km_total / v.diesel_total;
        }
        return v;
      })

      this.dados = {
        empresas: this.empresas.map((e) => {
          let veiculosEmpresa = this.veiculos.filter((v) => v.id_empresa == e.id_empresa && v.km_total && v.diesel_total);
          let viagensEmpresa = this.viagens.filter((v) => v.id_empresa == e.id_empresa && v.km_total_viagem)
          if (veiculosEmpresa.length > 0) {
            e.km_total = veiculosEmpresa.reduce((acc, curr) => curr.km_total + acc, 0);
            e.diesel_total = veiculosEmpresa.reduce((acc, curr) => curr.diesel_total + acc, 0);
            e.diesel_km = e.km_total / e.diesel_total || null;
            if (viagensEmpresa.length > 0) {
              e.km_ociosa = e.km_total - viagensEmpresa.reduce((acc, curr) => curr.km_total_viagem + acc, 0);
              e.ipk = viagensEmpresa.reduce((acc, curr) => curr.ipk + acc, 0);
            } else {
              e.km_ociosa = e.km_total;
            }
          }

          return e;
        }),
        linhas: this.linhas.map((l) => {
          let veiculosLinha = this.veiculos.filter((v) => v.id_linha == l.id_linha && v.km_total && v.diesel_total);
          let viagensLinha = this.viagens.filter((v) => v.id_linha == l.id_linha && v.km_total_viagem);
          if (veiculosLinha.length > 0) {
            l.km_total = veiculosLinha.reduce((acc, curr) => curr.km_total + acc, 0);
            l.diesel_total = veiculosLinha.reduce((acc, curr) => curr.diesel_total + acc, 0);
            l.diesel_km = l.km_total / l.diesel_total || null;
            if (viagensLinha.length > 0) {
              l.km_ociosa = l.km_total - viagensLinha.reduce((acc, curr) => curr.km_total_viagem + acc, 0);
              l.ipk = viagensLinha.reduce((acc, curr) => curr.ipk + acc, 0);
            } else {
              l.km_ociosa = l.km_total;
            }
          }
          return l;
        }),
        veiculos: this.veiculos.map((v) => {
          let viagensVeiculo = this.viagens.filter((e) => e.id_veiculo == v.id_veiculo);
          if (v.km_total) {
            if (viagensVeiculo.length > 0) {
              v.km_ociosa = v.km_total - viagensVeiculo.reduce((acc, curr) => curr.km_total_viagem + acc, 0);
              v.ipk = viagensVeiculo.reduce((acc, curr) => curr.ipk + acc, 0);
            } else {
              v.km_ociosa = v.km_total;
            }
          }
          return v;
        }),
        funcionarios: this.funcionarios.map((f) => {
          f.nome_motorista = f.nome;
          let viagensFuncionarios = this.viagens.filter((v) => v.id_funcionario_motorista == f.id_funcionario);
          if (viagensFuncionarios.length > 0) {
            f.km_total = viagensFuncionarios.reduce((acc, curr) => curr.km_total_viagem + acc, 0);
            f.ipk = Math.round(viagensFuncionarios.reduce((acc, curr) => curr.passageiros_totais + acc, 0) / f.km_total);
            f.diesel_total = viagensFuncionarios.reduce((acc, curr) => curr.diesel_total_viagem + acc, 0);
            f.diesel_km = f.km_total / f.diesel_total;
          }
          return f;
        })
      }

      this.loading = false;
    },
    onEmpresaSelectChanged() {
      if (this.idEmpresaSelected) {
        this.linhasSelect = this.linhas.filter((l) => l.id_empresa == this.idEmpresaSelected);
        this.veiculosSelect = this.veiculos.filter((v) => v.id_empresa == this.idEmpresaSelected);
        this.funcionariosSelect = this.funcionarios;
      } else {
        this.linhasSelect = [];
        this.veiculosSelect = [];
        this.funcionariosSelect = [];
      }
    },
    linhasSelectChanged() {
      this.idQuadroSelected = null;
      this.idViagemSelected = null;
    },
    veiculosSelectChanged() {
      this.idQuadroSelected = null;
      this.idViagemSelected = null;
    },
    funcionariosSelectChanged() {
      this.idQuadroSelected = null;
      this.idViagemSelected = null;
    },
    quadrosSelectChanged() {
      this.idViagemSelected = null;
    },
    viagensSelectChanged() {

    },
    selectIcon(selection, items) {
      if (selection.length === items.length) return 'mdi-close-box';
      if (selection.length > 0) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    toggleAllVeiculos() {
      this.$nextTick(() => {
        if (this.idVeiculoSelected.length === this.veiculosSelect.length) {
          this.idVeiculoSelected = [];
        } else {
          this.idVeiculoSelected = this.veiculosSelect.map((v) => v.id_veiculo);
        }
      })
    },
    toggleAllFuncionarios() {
      this.$nextTick(() => {
        if (this.idFuncionarioSelected.length === this.funcionariosSelect.length) {
          this.idFuncionarioSelected = [];
        } else {
          this.idFuncionarioSelected = this.funcionariosSelect.map((f) => f.matricula);
        }
      })
    },
  },
};
</script>